import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface TabItem {
  name: string;
  path: string;
}

export function SettingsLayout() {
  const { t } = useTranslation();

  const tabs: TabItem[] = [
    { name: t('settings.profile'), path: '/settings/profile' },
    { name: t('settings.security'), path: '/settings/password' },
    { name: t('settings.passkeys'), path: '/settings/passkeys' },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">{t('settings.title')}</h1>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
                  isActive
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                }`
              }
            >
              {tab.name}
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="py-4">
        <Outlet />
      </div>
    </div>
  );
}
